module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjIwMSIgdmlld0JveD0iMCAwIDMwMSAyMDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjMDA2QjNGIiBkPSJNLjUuNWgzMDB2MjAwSC41Ii8+PHBhdGggZmlsbD0iI0ZDRDExNiIgZD0iTS41LjVoMzAwdjEzMy4zMzNILjUiLz48cGF0aCBmaWxsPSIjQ0UxMTI2IiBkPSJNLjUuNWgzMDB2NjYuNjY3SC41Ii8+PHBhdGggZmlsbD0iIzAwMCIgZD0iTTExNC41IDkyLjVoNzAuNjY3TDEyOC41IDEzMy44MzMgMTQ5LjgzNCA2Ni41bDIyLjY2NiA2Ny4zMzMiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-gh.svg
// module id = bxyU
// module chunks = 2